import { atom, selectorFamily } from 'recoil'

export const pageState = atom({
  key: 'RcsSendStatusPageState',
  default: {
    loaded: false,
    loading: false,
    error: false,
    severity: 'danger'
  }
})

export const sendListState = atom({
  key: 'RcsSendStatusListState',
  default: {
    orderBy: 'UpdateDate',
    orderDescending: true,
    items: [],
    loading: true,
    isEmptyState: false
  }
})

export const modalConfirmState = atom({
  key: 'RcsSendStatusModalConfirmState',
  default: {
    action: '',
    idSending: null,
    modalConfirmShow: false,
    modalConfirmTitle: '',
    modalConfirmMessage: '',
    modalCofirmActionString: '',
    modalConfirmCancelString: '',
    modalConfirmVariant: ''
  }
})

export const modalShedulingState = atom({
  key: 'RcsSendStatusModallShedulingState',
  default: {
    isReschedule: false,
    show: false,
    startDate: '',
    scheduleTimeZoneCode: '',
    idScheduledSending: null
  }
})
